export default __webpack_public_path__ + "static/media/signin_banner.c3dea8fb.png";